import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { LoginBrandPanel } from '../components/auth/LoginBrandPanel';
import { LoginFormCard } from '../components/auth/LoginFormCard';
import { useAuth } from '../contexts/AuthContext';

export const Login = () => {
  const { isAuthenticated, loading, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const redirectTo = location.state?.from?.pathname || '/';

  const handleLogin = async () => {
    setLoginError('');
    setSubmitting(true);

    try {
      await login({ username, password });
      navigate(redirectTo, { replace: true });
    } catch (error) {
      setLoginError(
        error.response?.data?.message ||
        error.message ||
        'No se ha podido iniciar sesion. Revisa usuario y contrasena.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (!loading && isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Grid
      container
      sx={{
        minHeight: '100vh',
        width: '100%',
        bgcolor: 'background.default',
      }}
    >
      <Grid size={{ xs: 12, md: 5, lg: 4 }}>
        <LoginBrandPanel />
      </Grid>

      <Grid
        size={{ xs: 12, md: 7, lg: 8 }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: { xs: 'calc(100vh - 172px)', sm: 'calc(100vh - 188px)', md: '100vh' },
          px: { xs: 2, sm: 4, md: 6 },
          py: { xs: 3, sm: 4, md: 6 },
          bgcolor: 'background.default',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 440 }}>
          <LoginFormCard
            username={username}
            setUsername={setUsername}
            password={password}
            setPassword={setPassword}
            loading={submitting}
            error={loginError}
            onLogin={handleLogin}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
